import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionTemplateSetBlacklistPayload } from 'api/actions/revision-template-set-blacklist/revision-template-set-blacklist-payload';
import { RevisionTemplateSetBlacklistPathParameters } from 'api/actions/revision-template-set-blacklist/revision-template-set-blacklist-path-parameters';
import { RevisionTemplateSetBlacklistResponse } from 'api/actions/revision-template-set-blacklist/revision-template-set-blacklist-response';

type RevisionTemplateSetBlacklistQueryParameters = Record<string, any>;

/**
 * The path of the RevisionTemplateSetBlacklist action.
 */
export const revisionTemplateSetBlacklistActionPath = new SweetPath<keyof RevisionTemplateSetBlacklistPathParameters>(
  '/api/revision-template/blacklist/{revisionTemplateId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionTemplateSetBlacklist actions.
 */
export default function createRevisionTemplateSetBlacklistAction(axios: AxiosInstance) {
  return function revisionTemplateSetBlacklistAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionTemplateSetBlacklistPathParameters;
    query?: RevisionTemplateSetBlacklistQueryParameters;
    payload: RevisionTemplateSetBlacklistPayload;
  }) {
    const path = revisionTemplateSetBlacklistActionPath.insert(parameters);

    return axios.request<RevisionTemplateSetBlacklistResponse, RevisionTemplateSetBlacklistResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
